<template>
    <div class="page">
        <div v-if="loading" class="loading">
            <a-spin tip="加载中..." size="large"></a-spin>
        </div>
        <div v-else class="size" ref="pageRef">
            <div v-if="expireFlag">
                <div class="class box">
                    <div class="dfsb class-name">
                        {{ classInfo.className }}
                        <span><span style="font-size: 22px;">{{ classInfo.classPeriodNum }}</span> /{{
                            classInfo.totalPeriodNum }}</span>
                    </div>
                    <div class="class-info">
                        <div class="infomation">
                            <div class="pic">
                                <img :src="classInfo.coverUrl" @click="preview(classInfo.coverUrl)"
                                    v-if="classInfo.coverUrl">
                                <img src="../../../public/images/defaultImg.png" v-else>
                            </div>
                            <div class="text">
                                <div>第{{ classInfo.classPeriodNum }}课</div>
                                <p>{{ classInfo.title }}</p>
                            </div>
                        </div>
                        <div v-if="type == 1" style="margin: 10px 0 6px;" class="fwb">
                            <a-icon type="clock-circle" class="mr-7" />{{ classInfo.attendDate }}
                            周{{ classInfo.tomorrowDay }}<span v-if="dateType">({{ dateType }})</span>
                            {{ classInfo.classTime }}
                        </div>
                        <div v-if="type == 1 && classInfo.placeName" class="fwb">
                            <a-icon type="environment" class="mr-7" />{{ classInfo.placeName }}
                        </div>
                    </div>
                    <div class="avatar" :class="{ 'mb-0': type == 2 }">
                        <div class="pic" v-if="classInfo.imgUrl">
                            <img :src="classInfo.imgUrl" />
                        </div>
                        <div class="pic-round" v-else :style="{ backgroundColor: teacherInfo.avatarBgColor }">
                            {{ teacherInfo.firstWord }}
                        </div>
                        <div class="text" v-if="classInfo.teacherName">{{ classInfo.teacherName }}，主讲老师</div>
                        <div class="text" v-else>暂未设置主讲老师</div>
                    </div>
                    <!-- 课程提醒 -->
                    <div class="box1" v-if="type == 1">
                        <p>本次课程总时长{{ classInfo.classDuration }}分钟，含课间休息时间。</p>
                        <p>本次课程的主要教学目标为：</p>
                        <div>
                            {{ classInfo.content }}
                        </div>
                    </div>
                </div>
                <!-- 课程总结 -->
                <div v-if="type == 2">
                    <div class="box" v-if="scheduleContent">
                        <div class="dfsb box-title">教学内容</div>
                        <div class="box-content">{{ scheduleContent }}</div>
                    </div>
                    <div class="box evaluate">
                        <div class="dfsb box-title">课程表现</div>
                        <div class="mg-18" :class="{ 'level1': commentLevel == 1, 'level2': commentLevel == 2 }">
                            <img v-if="commentLevel == 3" src="../../../public/operation/good.png">
                            <img v-if="commentLevel == 2" src="../../../public/operation/general.png">
                            <img v-if="commentLevel == 1" src="../../../public/operation/bad.png">
                            {{ commentLevel == 1 ? '表现一般，需要努力！' : commentLevel == 2 ? '表现良好，继续加油！' : '表现优秀，值得鼓励！' }}
                        </div>
                        <div class="box-content">{{ commentContent }}</div>
                    </div>
                    <div class="box" v-if="imgs.length">
                        <div class="dfsb box-title">
                            精彩瞬间
                            <span style="font-weight: normal;font-size: 14px;">共计{{ imgs.length }}张</span>
                        </div>
                        <div class="img-box">
                            <div class="img" v-for="(item, index) in imgs" :key="index"
                                :style="{ width: imgWidth + 'px', height: imgWidth + 'px' }">
                                <img :src="item" mode="aspectFill" @click="preview(item)"
                                    :style="{ marginRight: imgMargin }">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="remind box" v-if="type == 1">
                    <div class="title">课程提示</div>
                    <p>1、请提醒孩子准时参加课程；</p>
                    <p>2、请孩子在上课时遵守课堂纪律，听从老师安排；</p>
                    <p>3、如课程含有专用教材教具，请提醒孩子携带对应教材教具参与课程学习；</p>
                    <p>4、如果无法参加课程，请点击下方“在小程序中查看”按钮，并进行请假操作；</p>
                    <p>5、课程结束后AI助教会推送对应课程总结，如果有任何问题或课程建议，请在课程总结处进行投诉或反馈。</p>
                </div>
                <div class="btn">
                    <div v-if="type == 2" class="tip">您可点击下方<span
                            style="color: #0089FF;">"在小程序中查看"</span>按钮，对老师进行评价反馈，或联系我们运营人员。</div>
                    <p>*为了保护您的隐私，本链接将在{{ classInfo.expireTime }}失效</p>
                    <p v-if="type == 2">失效后您依旧可以在小程序中参看本课程总结</p>
                    <!-- 微信开放标签 -->
                    <wx-open-launch-weapp id="launch-btn" :appid="appId" :path="path">
                        <script type="text/wxtag-template">
                            <style>
                                .btn { background: #0089FF; border-radius: 8px; color: #fff; margin-top: 44px;border:none; height:44px; line-height:44px; text-align: center; padding: 0 112px;  }
                            </style>
                            <button class="btn">在小程序中查看</button>
                        </script>
                    </wx-open-launch-weapp>
                </div>
            </div>
            <div v-else class="expire">
                <a-empty :description="false" />
                本链接已失效
            </div>
        </div>
    </div>
</template>

<script>
import dayjs from "dayjs";
import avatarBgColor from "../../api/avatarBgColor";
import qywx from '../../api/third-qywx';
const weekdays = ['日', '一', '二', '三', '四', '五', '六']
const huliBureauIds = [118, 441]
export default {
    name: "classNoticve",
    ignoredElements: ['wx-open-launch-weapp'],
    data() {
        return {
            type: 0, //  1课程提醒 2课程总结
            ts: 0, // 推送时间戳
            classList: [],
            teacherInfo: {},
            summaryInfo: {},
            classInfo: {},
            scheduleContent: '',
            studentInfo: {},
            loading: true,
            errFlag: false,
            expireFlag: true,
            commentContent: '',
            imgs: [],
            commentLevel: 0,
            appId: '', // 微信小程序id
            path: '', // 跳转小程序的路径
            GZappId: 'wxbe54b2d248eb6c6a', // 服务号的appId
            imgMargin: 0,
            imgWidth: 0,
        }
    },
    created() {
    },
    mounted() {
        this.ts = location.search.match(/ts=([\w-]+)(&|$)/) ? location.search.match(/ts=([\w-]+)(&|$)/)[1] : ''
        if (!this.ts) {
            this.loadWXSDK()
        } else {
            if (dayjs().isAfter(dayjs(Number(this.ts)).add(7, 'day'))) {
                this.expireFlag = false
                this.loading = false
            } else {
                this.loadWXSDK()
            }
        }
    },
    computed: {
        // 计算日期类型
        dateType() {
            if (!this.classInfo.attendDate) return '';
            const today = dayjs().format('YYYY-MM-DD');
            const tomorrow = dayjs().add(1, 'day').format('YYYY-MM-DD');
            if (this.classInfo.attendDate === today) {
                return '今日';
            } else if (this.classInfo.attendDate === tomorrow) {
                return '明日';
            } else {
                return '';
            }
        }
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.getImgWidth)
    },
    methods: {
        getData() {
            let id = location.search.match(/id=([\w-]+)(&|$)/)[1]
            let key = location.search.match(/key=([\w-]+)(&|$)/)[1]
            let type = location.search.match(/type=([\w-]+)(&|$)/)[1]
            this.type = type
            this.$nextTick(() => {
                const newTitle = type == 1 ? '上课提醒' : '课后总结'
                document.title = newTitle
                // 阻止标题被修改
                Object.defineProperty(document, 'title', {
                    get: function () {
                        return newTitle;
                    },
                    set: function (value) {
                        // 不做任何操作，阻止修改
                    },
                    configurable: false // 防止被再次修改
                });
            })
            let params = {
                type,
                ts: this.ts || '',
            }
            qywx.getNoticeInfo(id, key, params).then(res => {
                this.appId = huliBureauIds.includes(res.data.bureauId) ? 'wxac022809df8c7a43' : res.data.bureauId == 443 ? 'wxf296d03ebe216310' : 'wx811409757948cd8f'
                this.path = `pages/index/thirdJudge/thirdJudge?id=${res.data.scheduleDateTimeDTO.id}`
                this.classInfo = res.data.scheduleDateTimeDTO
                this.scheduleContent = res.data.scheduleContent
                this.classInfo.attendDate = dayjs(this.classInfo.attendDate).format('YYYY-MM-DD')
                this.classInfo.tomorrowDay = weekdays[dayjs(this.classInfo.attendDate).day()]
                // 计算时长
                const today = dayjs().format('YYYY-MM-DD');
                const [startTimeStr, endTimeStr] = this.classInfo.classTime.split('-');
                const startTime = dayjs(today + ' ' + startTimeStr);
                const endTime = dayjs(today + ' ' + endTimeStr);
                const durationMinutes = endTime.diff(startTime, 'minute');
                this.classInfo.classDuration = durationMinutes
                this.teacherInfo.avatarBgColor = avatarBgColor(this.classInfo.teacherId || 0)
                this.teacherInfo.firstWord = this.classInfo.teacherName ? this.classInfo.teacherName.substring(0, 1) : '无'
                // 计算有效期
                this.classInfo.expireTime = dayjs(this.classInfo.attendDate).add(7, 'day').format('YYYY-MM-DD 23:59')
                if (this.type == 2) {
                    this.commentLevel = res.data.commentLevel
                    this.commentContent = res.data.commentContent ? res.data.commentContent : ''
                    this.imgs = res.data.commentImgList ? res.data.commentImgList : []
                }
                this.loading = false
                if (type == 2) {
                    this.$nextTick(() => {
                        window.addEventListener('resize', this.getImgWidth)
                        this.getImgWidth()
                    })
                }
            }).catch(err => {
                this.expireFlag = false
                this.loading = false
            })
        },
        loadWXSDK() {
            const script = document.createElement('script');
            script.src = 'https://res.wx.qq.com/open/js/jweixin-1.6.0.js';
            script.onload = () => {
                this.getSignature()
                this.getData()
            };
            document.body.appendChild(script);
        },
        getSignature() {
            const currentUrl = window.location.href.split('#')[0];
            let params = { url: currentUrl }
            qywx.getSignature(this.GZappId, params).then(res => {
                this.initWXConfig(res.data)
            })
        },
        initWXConfig(params) {
            wx.config({
                debug: false, // 开启调试模式
                appId: this.GZappId, // 服务号的appId
                timestamp: params.timestamp, // 生成签名的时间戳
                nonceStr: params.nonceStr, // 生成签名的随机串
                signature: params.signature, // 签名
                jsApiList: ['previewImage'], // 需要使用的JS接口列表
                openTagList: ['wx-open-launch-weapp']
            });
            wx.ready(() => {
                // alert('SDK 初始化完成，开放标签可用');
            });

            wx.error(err => {
                // alert('SDK 初始化失败' + JSON.stringify(err));
            });
        },
        preview(url) {
            wx.previewImage({
                current: url,
                urls: [url],
            });
        },
        getImgWidth() {
            if (this.$refs.pageRef) {
                const rect = this.$refs.pageRef.getBoundingClientRect()
                this.imgMargin = 0.02 * rect.width
                this.imgWidth = (rect.width - 32 - this.imgMargin * 3) / 3
                this.$forceUpdate()
            }
        },
    }

}
</script>

<style lang="less" scoped>
.page {
    padding: 16px 16px 46px;
    background: linear-gradient(180deg, #EBF8FF 0%, rgba(235, 248, 255, 0) 100%);
    min-height: 100vh;
    color: #3C454C;
}

.size {
    max-width: 500px;
    margin: 0 auto;
}

.loading {
    text-align: center;
    margin-top: 40vh;
}

.box {
    border: 1px solid #D8ECFF;
    padding: 16px;
    background-color: #fff;
    margin-bottom: 12px;
    border-radius: 10px;
}

.box1 {
    padding: 16px;
    background-color: #F7FAFF;
    border-radius: 10px;
    color: #3D3D3D;
}

.dfsb {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: bold;
}

.mb-10 {
    margin-bottom: 10px;
}

.mb-0 {
    margin-bottom: 0 !important;
}

.mg-18 {
    margin: 18px 0;
}

.mr-7 {
    margin-right: 7px;
}

.fwb {
    font-weight: bold;
}

.class {

    .class-name {
        font-size: 16px;
        color: #333;
        margin-bottom: 10px;

        span {
            font-size: 12px;
        }
    }

    .class-info {
        padding-bottom: 12px;
        border-bottom: 1px solid #F6F7F8;

        .infomation {
            display: flex;
            align-items: center;

            .pic {
                width: 105px;
                min-width: 105px;
                height: 60px;
                background: #ccc;
                margin-right: 10px;
                border-radius: 10px;

                img {
                    width: 100%;
                    height: 100%;
                    border-radius: 10px;
                }
            }

            .text {
                color: #333;
                font-weight: bold;
            }
        }
    }

    .avatar {
        margin: 12px 0 10px;
        display: flex;
        align-items: center;

        .pic {
            width: 28px;
            height: 28px;
            background: #ccc;
            margin-right: 6px;
            border-radius: 50%;

            img {
                width: 100%;
                height: 100%;
                border-radius: 50%;
            }
        }

        .pic-round {
            width: 28px;
            height: 28px;
            border-radius: 50%;
            line-height: 26px;
            margin-right: 6px;
            text-align: center;
            font-size: 14px;
            color: #fff;
            font-weight: bold;
            border: 1px solid #fff;
        }

        .text {
            font-size: 12px;
            color: #3C454C;
        }
    }
}

.box-title {
    color: #333;
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 5px;
}

.box-content {
    color: #3D3D3D;
    font-weight: normal;
    font-size: 14px;
    white-space: pre-wrap;
}

.remind {
    margin-bottom: 10px;

    .title {
        font-weight: bold;
        font-size: 16px;
        margin-bottom: 10px;
    }
}

.btn {
    button {
        margin-top: 44px;
        width: 100%;
        height: 44px;
        border-radius: 8px;
    }

    p {
        font-size: 12px;
        font-weight: lighter;
        color: #ADA8A8;
    }

    .tip {
        font-weight: bold;
        text-align: left;
        margin: 12px 0 10px;
        color: #3D3D3D;
    }

    width: 100%;
    height: 100%;
    text-align: center;
}

.evaluate {
    color: #FF7300;
    font-weight: bold;
    font-size: 16px;

    img {
        margin-right: 22px;
        width: 84px;
    }
}

.level1 {
    color: #acbbdd;
}

.level2 {
    color: #fec889;

    img {
        width: 60px;
        height: 60px;
    }
}

.expire {
    padding-top: 35vh;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.img-box {
    margin-top: 18px;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;

    .img {
        border-radius: 6px;
        margin-right: 2%;

        img {
            width: 100%;
            height: 100%;
            border-radius: 6px;
            object-fit: cover;
        }
    }

    .img:nth-child(3n) {
        margin-right: 0;
    }

    .img:nth-child(n+4) {
        margin-top: 8px;
    }
}
</style>